import React, {useState} from 'react';
import {Button, Flex, Icon, Input, PriorityIcon} from '@priority-software/priority-style-react';
import {texts} from '../../../texts';

type Props = {
    searchName?: string;
    isDisabled?: boolean;
    onSearchTitleSave?: (title: string) => void;
    onClose: () => void;
};

export const SearchTitleBox = (props: Props) => {
    const {searchName, isDisabled, onSearchTitleSave, onClose} = props;
    const [searchTitle, setSearchTitle] = useState(searchName || '');

    const onSave = () => {
        if (searchTitle) {
            onSearchTitleSave(searchTitle);
        }
    };

    return (
        <Flex paddingTop componentClasses="save-row" style={{gap: 16}}>
            <Input
                size="large"
                value={searchTitle}
                placeholder={texts.saveAndSearchPlaceholder}
                autoFocus={true}
                onChange={e => setSearchTitle(e.target.value)}
                onKeyDown={e => {
                    if (e.key === 'Enter') {
                        onSave();
                    }
                }}
            />

            <Button
                disabled={isDisabled || searchTitle.length === 0}
                width="contentWidth"
                size="medium"
                onClick={onSave}
            >
                {texts.searchSaveBtn}
            </Button>

            <Icon icon={PriorityIcon.closeSmall} skin="standart" onClick={onClose} />
        </Flex>
    );
};
